module.exports = __webpack_public_path__ + "img/6.24d59a07.png";